import CollectionList from '@/js/Shared/Collections/CollectionList.js';
import AccountSendersItem from '../Entities/AccountSendersItem.js';
import CollectionSearch   from '@/js/Shared/Collections/CollectionSearch.js';

export { AccountSendersCollectionList as default };

/**
* whitelist Collection List
*
* @author      rsommerfeld <roni.s.sommerfeld@altice.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class AccountSendersCollectionList extends CollectionList
{
  search_list = new CollectionSearch('sender');

  constructor(index_id) {
    super(index_id);

    this.search_list.setSearchList(this);
  }

  /**
   * Returns a email from whitelist on the list by the given id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id email from whitelist id
   *
   * @return {WhitelistItem}
   */
  get(id) {
    return this.index[id] || new AccountSendersItem();
  }

  /**
   * Resorts email whitelist items alphabeticly
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  resortItems() {
    this.items.sort((a,b) => {
      return a.sender.localeCompare(b.sender, undefined, { numeric: true });
    })
  }

  search(term) {
    this.search_list.term = term;
    this.search_list.search(term, {
      sender: ['lower_case', 'latinize'],
    })
  }
}